import { createAction } from 'redux-actions';
import { getUserGroupInfo } from '../../common/service/user';
import STATUS_CODE from '../../../request/statusCode';
import { RESET, SET_LOADING, SET_USER_GROUP } from './actionTypes';

const INITIAL_USER_GROUPS = {
  groups: []
};

const reset = createAction(RESET);

const setUserGroups = createAction(SET_USER_GROUP);

const setLoading = createAction(SET_LOADING);

const getUserGroups = ({ userName }) => {
  return dispatch => {
    dispatch(setLoading(true));
    return getUserGroupInfo({ userName }).then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        const { groups } = res.data;
        return dispatch(
          setUserGroups({
            groups
          })
        );
      }
      return dispatch(setUserGroups(INITIAL_USER_GROUPS));
    });
  };
};

export { getUserGroups, setUserGroups, reset, setLoading, INITIAL_USER_GROUPS };
